module.exports = __webpack_public_path__ + "img/trace.ed3702b6.png";